import React, { useEffect, useState } from 'react'
import { getAllDimensionByModelId, getAllModels, getAllSubDimensionById } from '../../../services/api-services';
import DropDownWithLabel from '../../components/common/DropDownWithlable';
import { CSVLink } from 'react-csv';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import axioAdmin from '../../../services/intercepters';
import { API_URL } from '../../../services/url-constant';
import { LOGO_IMG } from '../../../utills/image-constant';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes/url-constant';
import UploadModel from '../../components/common/UploadModal';

const CriteriaBulkUpload = ({ isModalOpen, setIsModalOpen, getListOfCriteria }) => {
    const navigation = useNavigate();
    const [downloadbtn, setDownloadbtn] = useState(true);
    const [modelList, setModelList] = useState([]);
    const [dimensionList, setDimensionList] = useState([]);
    const [subDimensionList, setSubDimensionList] = useState([]);
    const [modelData, setModelData] = useState("");
    const [dimensionData, setDimensionData] = useState("");
    const [subDimensionData, setSubDimensionData] = useState("");
    const [selectedFileName, setSelectedFileName] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [uploadApi, setUploadApi] = useState(false);
    const [formDataValue, setformDataValue] = useState("");
    const [formValue, setformValue] = useState(null);
    // const [bulkUploadcondition, setbulkUploadcondition] = useState(false);
    const [csvHeader, setcsvHeader] = useState([{ label: 'criteriaShortLabel', key: 'criteriaShortLabel' },
    { label: 'criteriaDescription', key: 'criteriaDescription' },
    { label: 'initiatingDescription', key: 'initiatingDescription' },
    { label: 'emergingDescription', key: 'emergingDescription' },
    { label: 'performingDescription', key: 'performingDescription' },
    { label: 'advancingDescription', key: 'advancingDescription' },
    { label: 'leadingDescription', key: 'leadingDescription' },
    ])

    const getListOfModel = async () => {
        try {
            const response = await getAllModels(1);
            if (response?.data?.responseCode === 404) {
                setModelList([]);
                setDimensionList([]);
                setSubDimensionList([]);
            }
            else if (response?.data?.responseCode === 200) {
                const modelOptions = response?.data?.responseBody?.map((model) => ({
                    value: model.id,
                    label: model.modelName,
                    Status: model.status,
                }));
                setModelList(modelOptions);
            } else {
                setModelList([]);
                setDimensionList([]);
                setSubDimensionList([]);
            }
        } catch (err) {
        }
    };

    useEffect(() => {
        getListOfModel();
    }, []);

    const getListOfDimension = async (id) => {
        try {
            const response = await getAllDimensionByModelId(id, 1);
            if (response?.data?.responseCode === 404) {

                setDimensionList([]);
                setSubDimensionList([]);
            }
            else if (response?.data?.responseCode === 200) {
                const modelOptions = response?.data?.responseBody?.map((model) => ({
                    value: model.id,
                    label: model.dimensionName,
                    Status: model.status,
                }));
                setDimensionList(modelOptions);
            } else {


                setDimensionList([]);
                setSubDimensionList([]);

            }
        } catch (err) {
            console.error(err);
        }
    };

    const getListOfsubDimension = async (id) => {
        try {
            const response = await getAllSubDimensionById(id, 1);
            if (response?.data?.responseCode === 404) {
                setDimensionList([]);
                setSubDimensionList([]);
            }
            else if (response?.data?.responseCode === 200) {
                const subDimensionOptions = response?.data?.responseBody?.map((model) => ({
                    value: model.id,
                    label: model.subDimensionName,
                    Status: model.status,
                }));
                setSubDimensionList(subDimensionOptions);
            } else {
                setDimensionList([]);
                setSubDimensionList([]);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleSelectValue = (event) => {
        const { name, value } = event.target;
        if (name === "modelList") {
            setModelData(value);
            setSubDimensionData("")
            setDimensionData("")
            getListOfDimension(value);
        } else if (name === "dimensionList") {
            getListOfsubDimension(value)
            setDimensionData(value)
        } else if (name === "subDimensionList") {
            setSubDimensionData(value);
            setDownloadbtn(false)
        }
    };

    const BulkUploadCriteria = async (modelId, dimensionId, subDimensionId, formData) => {
        try {
            const response = await axioAdmin.post(
                `${API_URL?.CriteriaManagement?.BulkUpload}?modelId=${modelId}&dimensionId=${dimensionId}&subDimensionId=${subDimensionId}`,
                formData, // Pass FormData directly
                {
                    headers: {
                        // No need to set Content-Type explicitly
                        // Axios sets it automatically for FormData
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error in BulkUploadCriteria:", error);
            throw error; // Propagate the error for handling
        }
    };


    const handleChange = async (event) => {
        event.preventDefault();
        setformValue(event.target.value)
        const file = event?.target?.files[0];

        if (!file || file?.type !== "text/csv") {
            event.target.value = null;  // Reset the input field
            setUploadApi(false);
            return toastEmitter("error", "Please upload a valid CSV file!");
        }

        const formdata = new FormData();
        formdata.append("file", file);
        setSelectedFileName(file?.name);
        setformDataValue(formdata);
        setUploadApi(true);
        setModalOpen(true);

        // Reset the input field so it triggers again even with the same file
        event.target.value = null;
    };

    const handlebulkupload = async () => {
        if (uploadApi === true) {
            try {
                const response = await BulkUploadCriteria(modelData, dimensionData, subDimensionData, formDataValue);
                if (response?.responseCode == 400) {
                    //   navigate(navigationURL);
                    toastEmitter("error", response?.message);
                    setformValue(null)
                    setModalOpen(false)
                    // setformDataValue("")

                } else if (response?.responseCode == 200) {
                    setIsModalOpen(false)
                    setModalOpen(false)
                    toastEmitter("success", response?.message);
                    setformValue(null)
                    getListOfCriteria();
                    // setformDataValue("")
                    setModelData([])
                    setDimensionList([])
                    setSubDimensionList([])
                } else {
                    toastEmitter("error", response?.message);
                    // getListOfCriteria();
                    setformValue(null)
                }
            } catch (err) {
                setformValue(null)
                setModalOpen(false)
                // setformDataValue("")
                toastEmitter("error", API_RESPONSE.MESSAGE_503);
            }
        }
    }

    // const handleDownload = () => {
    //     const link = document.createElement('a');
    //     link.href = "excelfile/BulkUploadFormate.csv" // Path to your CSV file in the public folder
    //     link.download = 'Criteria.csv'; // Name for the downloaded file
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

     const handleDownload = () => {
       const baseUrl = API_URL.fileURL; 
        const link = document.createElement("a");
        // const locale = navigator.language || "en-US";
        // const commaLocales = ["en-US","en", "en-IN", "en-GB", "en-CA", "en-AU"];
        // const isComma = commaLocales.some(l => locale.startsWith(l));
        // if(isComma==true){
        //   link.href = `${baseUrl}/en/Criteriabulkupload.csv`;
        // }else{
        //   link.href = `${baseUrl}/fr/Criteriabulkupload.csv`;
        // }
         link.href = `${baseUrl}/fr/Criteriabulkupload.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    return (
        <div>
            <div
                className={`modal fade ${isModalOpen ? "show" : ""}`} style={{ display: isModalOpen ? 'block' : 'none', background: isModalOpen ? 'rgba(0,0,0,0.5)' : '' }}
            >
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content p-5">
                        <div className='d-flex justify-content-end align-items-center'>
                            <button type="button" class="btn-close" aria-label="Close" onClick={() => setIsModalOpen(false)}></button>
                        </div>

                        <div className='d-flex justify-content-center align-items-center'>
                            <img src={LOGO_IMG} class="img-fluid mb-4 logo_img" alt="..." />
                        </div>

                        <div className="modal-body border-0">
                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <DropDownWithLabel
                                        name="modelList"
                                        labelName="Select Maturity Model"
                                        className="inputText-lable"
                                        lableclassName="input-label"
                                        options={modelList}
                                        value={modelData}
                                        handleSelect={handleSelectValue}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <DropDownWithLabel
                                        labelName="Select Dimension"
                                        name="dimensionList"
                                        options={dimensionList}
                                        lableclassName="input-label"
                                        value={dimensionData}
                                        handleSelect={handleSelectValue}
                                        className="inputText-lable"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <DropDownWithLabel
                                        labelName="Select Sub-Dimension"
                                        name="subDimensionList"
                                        options={subDimensionList}
                                        lableclassName="input-label"
                                        value={subDimensionData}
                                        handleSelect={handleSelectValue}
                                        className="inputText-lable"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-6 d-flex justify-content-end align-items-center'>
                                {/* <CSVLink
                                data={[]}
                                filename={"Criteria.csv"}
                                className="btn btn-primary"
                                target="_blank"
                                headers={csvHeader}
                            >
                                Download CSV Formate Here.
                            </CSVLink> */}
                                <button className="btn btn-primary" onClick={handleDownload}> Download CSV Formate Here.</button>
                            </div>
                            <div className='col-6 d-flex justify-content-start align-items-center'><button
                                type="button"
                                className="btn btn-danger px-5"
                                disabled={downloadbtn}
                                onClick={() => document.getElementById('file-upload').click()}
                            >
                                Upload CSV
                            </button>
                                <input
                                    id="file-upload"
                                    type="file"
                                    onChange={(e) => handleChange(e)}
                                    style={{ display: 'none' }} // This hides the input element
                                /></div>
                        </div>
                    </div>
                </div>
            </div>
            <UploadModel modalOpen={modalOpen} setModalOpen={setModalOpen} uploadApi={uploadApi} setUploadApi={setUploadApi} handlebulkupload={handlebulkupload} selectedFileName={selectedFileName} setModelData={setModelData} setSubDimensionList={setSubDimensionList} setDimensionList={setDimensionList} />
        </div>
    )
}

export default CriteriaBulkUpload
